import React from "react";

import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const Admission = () => {
  const navigate = useNavigate();

  const { isLoading, error, data } = useQuery("Admission", () =>
    fetch(
      "https://cufeed.apis.bluespacejp.com/api/v1/blogPosts?category=Admission"
    ).then((res) => res.json())
  );

  return (
    <div>
      <div className="py-[3px]">
        <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
          <div className="card-body py-2 items-center text-center">
            <img className="w-[30px]" src="/culogo.png" alt="" />

            <h2 className="card-title text-white">Admission</h2>
          </div>
        </div>
      </div>

      {!navigator.onLine ? (
        <div className="text-center py-[150px]">
          <p>No internet. Please check your internet connection.</p>
        </div>
      ) : isLoading ? (
        <div className="grid justify-items-center py-[100px]">
          <div className="flex flex-col gap-4 w-52">
            <div className="skeleton h-32 w-full"></div>
            <div className="skeleton h-4 w-28"></div>
            <div className="skeleton h-4 w-full"></div>
            <div className="skeleton h-4 w-full"></div>
          </div>
        </div>
      ) : !data?.length ? (
        <div className="text-center py-[160px]">
          <p>Sorry!!! No data found now.</p>
          <p>Happy to see you next time.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mx-2">
          {data?.map((post, index) => {
            return (
              <div
                key={index}
                onClick={() => navigate(`/postDetails/${post?._id}`)}
                className="card w-full glass"
              >
                {/* <figure>
                      <img src={`${post?.image}`} alt={`${post?.title}`} />
                    </figure> */}
                <div className="card-body">
                  <h2 className="card-title">{post?.title}</h2>

                  <h3>{post?.department}</h3>
                  <p>{post?.description.substring(0, 80)}...</p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {error ? `${error.message}` : ""}
    </div>
  );
};

export default Admission;
